module.exports = __webpack_public_path__ + "static/orr-histology-mobile-c0b3111e701c555cff69df46c1ff0628.png";